import { waLink, WA_MESSAGES } from "@/lib/business";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <a
    href={waLink(WA_MESSAGES.general)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Conversar com a Ótica Danko pelo WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 hover:shadow-xl active:scale-95 transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2"
  >
    <WhatsAppIcon className="w-7 h-7" />
  </a>
);
